
<div class='previewModal'>
<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{fileName}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    
</div>
<div class="modal-body">
    <div class='docViewer py-2'>
    
        <pdf-viewer [src]="fileUrl!"
              [render-text]="true"
              [stick-to-page]="true" 
              [show-all]="true"
              [original-size]="true"
              [autoresize]="true"
              [zoom]="zoom_to"
              [(page)] = "page"
              [stick-to-page]="false"
              [show-borders]="true"
              ></pdf-viewer>
    </div>
    
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)='previousPage()'><i class="bi bi-caret-left"></i> </button>
    <button type="button" class="btn btn-primary" (click)='nextPage()'><i class="bi bi-caret-right"></i> </button>
    <button type="button" class="btn btn-primary" (click)='zoomIn()'><i class="bi bi-zoom-in"></i> </button>
    <button type="button" class="btn btn-primary" (click)='zoomOut()'><i class="bi bi-zoom-out"></i> </button>
    <button type="button" class="btn btn-outline-dark" (click)="download()">{{ 'general.download' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="print()">{{ 'general.print' | translate }}</button>
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
  
</div>
</div>